export default __webpack_public_path__ + "static/media/zappos.791e7f8a.svg";